import React from 'react';
import { Select, Text } from '@/components/ui';
import { useScale } from '@/hooks/useScale.ts';
import type { ScaleValue } from '@/providers/ScaleContext';

export type { ScaleValue } from '@/providers/ScaleContext';

interface ScaleControlProps {
  variant?: 'select' | 'settings';
  showLabel?: boolean;
}

export function ScaleControl({
  variant = 'select',
  showLabel = true,
}: ScaleControlProps) {
  const { scale, setScale } = useScale();

  const scaleOptions = [
    { value: '0.9', label: '90%' },
    { value: '0.95', label: '95%' },
    { value: '1', label: '100%' },
    { value: '1.05', label: '105%' },
    { value: '1.1', label: '110%' },
  ];

  // Radix UI scaling is now handled in ThemeProvider
  // No need to manually set data-scaling attribute

  if (variant === 'select') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {showLabel && (
          <Text weight="medium" style={{ marginBottom: '0.5rem' }}>
            Interface Scale
          </Text>
        )}
        <Select
          value={scale}
          onValueChange={(value: string) => setScale(value as ScaleValue)}
          options={scaleOptions}
          placeholder="Select scale"
        />
      </div>
    );
  }

  if (variant === 'settings') {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <Text weight="medium">Interface Scale</Text>
          <Text size="3xsmall" color="secondary">
            Adjust the size of interface elements
          </Text>
        </div>
        <div style={{ minWidth: 120 }}>
          <Select
            value={scale}
            onValueChange={(value: string) => setScale(value as ScaleValue)}
            options={scaleOptions}
          />
        </div>
      </div>
    );
  }

  return null;
}
